/**
 * 课程组api
 * 课程组api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../user/model/CreatedVo';
import IdNameVo from '../../user/model/IdNameVo';
import PagingTeamCourseVo from '../../user/model/PagingTeamCourseVo';
import PagingTeamMemberVo from '../../user/model/PagingTeamMemberVo';
import PagingTeamVo from '../../user/model/PagingTeamVo';
import TeamCourseCreateForm from '../../user/model/TeamCourseCreateForm';
import TeamCreateForm from '../../user/model/TeamCreateForm';
import TeamDetailVo from '../../user/model/TeamDetailVo';
import TeamMemberCreateForm from '../../user/model/TeamMemberCreateForm';
import TeamMemberEditForm from '../../user/model/TeamMemberEditForm';
import UpdatedVo from '../../user/model/UpdatedVo';
  /**
   * Team service.
   * @module user/api/TeamApi
   * @version 0.2.0
   */

  /**
   * Constructs a new TeamApi. 
   * @alias module:user/api/TeamApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 新增课程组
     * @param {module:user/model/TeamCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/CreatedVo}
     */
this.add = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling add";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/team/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新增课程组课程
     * @param {Integer} teamId team id
     * @param {module:user/model/TeamCourseCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/CreatedVo}
     */
this.courseAdd = function(teamId, body) {
      var postBody = body;

      // verify the required parameter 'teamId' is set
      if (teamId == undefined || teamId == null) {
        throw "Missing the required parameter 'teamId' when calling courseAdd";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling courseAdd";
      }


      var pathParams = {
        'teamId': teamId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/team/{teamId}/course', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 课程组课程列表
     * @param {Integer} teamId team id
     * @param {Integer} pageNum 当前页
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/PagingTeamCourseVo}
     */
this.courseList = function(teamId, pageNum) {
      var postBody = null;

      // verify the required parameter 'teamId' is set
      if (teamId == undefined || teamId == null) {
        throw "Missing the required parameter 'teamId' when calling courseList";
      }

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling courseList";
      }


      var pathParams = {
        'teamId': teamId
      };
      var queryParams = {
        'pageNum': pageNum
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingTeamCourseVo;
      return this.apiClient.callApi(
        '/api/team/{teamId}/course', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除课程组课程
     * @param {Integer} teamId team id
     * @param {Integer} teamCourseId team course id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/UpdatedVo}
     */
this.courseRemove = function(teamId, teamCourseId) {
      var postBody = null;

      // verify the required parameter 'teamId' is set
      if (teamId == undefined || teamId == null) {
        throw "Missing the required parameter 'teamId' when calling courseRemove";
      }

      // verify the required parameter 'teamCourseId' is set
      if (teamCourseId == undefined || teamCourseId == null) {
        throw "Missing the required parameter 'teamCourseId' when calling courseRemove";
      }


      var pathParams = {
        'teamId': teamId,
        'teamCourseId': teamCourseId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/team/{teamId}/member/{teamCourseId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取课程组详情
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/TeamDetailVo}
     */
this.detail = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling detail";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = TeamDetailVo;
      return this.apiClient.callApi(
        '/api/team/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改课程组
     * @param {Integer} id id
     * @param {module:user/model/TeamCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/UpdatedVo}
     */
this.edit = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling edit";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling edit";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/team/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 返回全部课程组
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:user/model/IdNameVo>}
     */
this.list = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [IdNameVo];
      return this.apiClient.callApi(
        '/api/team/list', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新增课程组成员
     * @param {Integer} teamId team id
     * @param {module:user/model/TeamMemberCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/CreatedVo}
     */
this.memberAdd = function(teamId, body) {
      var postBody = body;

      // verify the required parameter 'teamId' is set
      if (teamId == undefined || teamId == null) {
        throw "Missing the required parameter 'teamId' when calling memberAdd";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling memberAdd";
      }


      var pathParams = {
        'teamId': teamId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/team/{teamId}/member', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改课程组成员
     * @param {Integer} teamId team id
     * @param {Integer} teamMemberId team member id
     * @param {module:user/model/TeamMemberEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/UpdatedVo}
     */
this.memberEdit = function(teamId, teamMemberId, body) {
      var postBody = body;

      // verify the required parameter 'teamId' is set
      if (teamId == undefined || teamId == null) {
        throw "Missing the required parameter 'teamId' when calling memberEdit";
      }

      // verify the required parameter 'teamMemberId' is set
      if (teamMemberId == undefined || teamMemberId == null) {
        throw "Missing the required parameter 'teamMemberId' when calling memberEdit";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling memberEdit";
      }


      var pathParams = {
        'teamId': teamId,
        'teamMemberId': teamMemberId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/team/{teamId}/member/{teamMemberId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 课程组成员列表
     * @param {Integer} teamId team id
     * @param {Integer} pageNum 当前页
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/PagingTeamMemberVo}
     */
this.memberList = function(teamId, pageNum) {
      var postBody = null;

      // verify the required parameter 'teamId' is set
      if (teamId == undefined || teamId == null) {
        throw "Missing the required parameter 'teamId' when calling memberList";
      }

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling memberList";
      }


      var pathParams = {
        'teamId': teamId
      };
      var queryParams = {
        'pageNum': pageNum
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingTeamMemberVo;
      return this.apiClient.callApi(
        '/api/team/{teamId}/member', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除课程组成员
     * @param {Integer} teamId team id
     * @param {Integer} teamMemberId team member id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/UpdatedVo}
     */
this.memberRemove = function(teamId, teamMemberId) {
      var postBody = null;

      // verify the required parameter 'teamId' is set
      if (teamId == undefined || teamId == null) {
        throw "Missing the required parameter 'teamId' when calling memberRemove";
      }

      // verify the required parameter 'teamMemberId' is set
      if (teamMemberId == undefined || teamMemberId == null) {
        throw "Missing the required parameter 'teamMemberId' when calling memberRemove";
      }


      var pathParams = {
        'teamId': teamId,
        'teamMemberId': teamMemberId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/team/{teamId}/member/{teamMemberId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询课程组
     * @param {Integer} pageNum 当前页
     * @param {Object} opts Optional parameters
     * @param {String} opts.name 课程组名
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/PagingTeamVo}
     */
this.page = function(pageNum, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling page";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'name': opts['name']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingTeamVo;
      return this.apiClient.callApi(
        '/api/team/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除课程组
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:user/model/UpdatedVo}
     */
this.remove = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling remove";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/team/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
